import _debounce from 'lodash/debounce';

export const TOGGLE_NAV_VISIBILITY = 'ui/TOGGLE_NAV_VISIBILITY';
export const toggleNavVisibility = () => ({ type: TOGGLE_NAV_VISIBILITY });

export const HIDE_NAV_VISIBILITY = 'ui/HIDE_NAV_VISIBILITY';
export const hideNavVisibility = () => ({ type: HIDE_NAV_VISIBILITY });

export const SET_MEDIA_STATE = 'ui/SET_MEDIA_STATE';
export const SET_PAGE_VISIBILITY = 'ui/SET_PAGE_VISIBILITY';

// Adapted from  https://github.com/classpass/classpass-frontend/blob/40dc703/app/src/decorators/Media/Media.js
export const MEDIA_QUERY_MAP = {
  xl: 'screen and (min-width: 80em)',
  lg: 'screen and (min-width: 62em)',
  md: 'screen and (min-width: 48em)',
  sm: 'screen and (min-width: 30em)',
  xs: 'screen and (min-width: 23.4375em)',
};

const THIRTY_FPS = 1000 / 30;

const matchMedia = dispatch => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  const breakpoint = Object.keys(MEDIA_QUERY_MAP).find(
    queryName => window.matchMedia(MEDIA_QUERY_MAP[queryName]).matches
  );
  dispatch({
    type: SET_MEDIA_STATE,
    breakpoint,
    viewportWidth: window.innerWidth,
  });
};

const onVisibilityChange = dispatch => {
  dispatch({
    type: SET_PAGE_VISIBILITY,
    foreground: !document.hidden,
  });
};

export const watchMediaState = dispatch => {
  const resizeHandler = _debounce(matchMedia.bind(null, dispatch), THIRTY_FPS);
  const visibilityHandler = onVisibilityChange.bind(null, dispatch);
  window.addEventListener('resize', resizeHandler);
  window.addEventListener('visibilitychange', visibilityHandler);
  matchMedia(dispatch);
};

const initialState = {
  navIsOpen: false,
  breakpoint: null,
  viewportWidth: 320,
  foreground: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_NAV_VISIBILITY:
      return { ...state, navIsOpen: !state.navIsOpen };
    case HIDE_NAV_VISIBILITY:
      return { ...state, navIsOpen: false };
    case SET_MEDIA_STATE:
      return { ...state, breakpoint: action.breakpoint, viewportWidth: action.viewportWidth };
    case SET_PAGE_VISIBILITY:
      return { ...state, foreground: action.foreground };
    default:
      return state;
  }
};
